import { render, staticRenderFns } from "./returnCheck.vue?vue&type=template&id=3a62e3d8&scoped=true"
import script from "./returnCheck.vue?vue&type=script&lang=js"
export * from "./returnCheck.vue?vue&type=script&lang=js"
import style0 from "./returnCheck.vue?vue&type=style&index=0&id=3a62e3d8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a62e3d8",
  null
  
)

export default component.exports